const getRandomId = (): number => Math.floor(Math.random() * 1000000000000000);

export default getRandomId;
